<template>
  <div class="content">
    <div class="content-body">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.content {
  width: 100%;
  margin: 0 auto;
  .content-body {
    margin: 24px 32px;
  }
}
</style>
